<div class="card h-100">
  <div class="card-header bg-white border-bottom">
    <h6 class="mb-0">Identity Exposure & Misconfiguration</h6>
    <span class="text-muted small">Top posture gaps by score impact</span>
  </div>
  <div class="card-body">
    @if (isLoading()) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (!identityScore()) {
      <div class="text-center text-muted py-4">
        <div class="mb-1">Not available yet</div>
      </div>
    } @else {
      @if (topFailingFactors().length) {
        <div echarts [options]="chartOptions()" style="height: 180px"></div>

        <!-- Always shown, not only when there are more than five: the count of what is
             rendered against the total is the point, and "5 of 5" is as informative as
             "5 of 9". -->
        <div class="text-muted small text-center mt-1">
          Showing top {{ topFailingFactors().length }} of {{ totalFailingCount() }}
          failing check{{ totalFailingCount() === 1 ? '' : 's' }}
        </div>

        <!-- Detection type mapping: the check's severity and the threat scenario it could
             enable. Both come from the catalog through the score payload; this widget keeps
             no mapping of its own. -->
        <div class="factor-details mt-2 pt-2 border-top">
          @for (factor of topFailingFactors(); track factor.check_id) {
            <div class="d-flex align-items-center gap-2 mb-1">
              @if (factor.severity) {
                <span [class]="getSeverityClass(factor.severity)">{{ factor.severity }}</span>
              }
              <small class="text-muted">{{ factor.name }}</small>
              @if (factor.detection_type) {
                <small class="text-muted">→</small>
                <small class="fw-semibold">{{ factor.detection_type }}</small>
              }
            </div>
          }
        </div>
      } @else {
        <div class="text-center text-muted py-4">
          <div class="mb-1">All evaluated checks passing</div>
          <small>No active deductions</small>
        </div>
      }

      <!-- Affected scope: one item per check shown above, in the same order.
           Read from `topFailingFactors()` rather than from `misconfig_summary`, which
           carries every failing check with no way to tell which five are on the chart -
           and 35 of the 40 production organisations fail more than five. Taking it from
           the same list the chart uses makes the count, the order and the exclusion of
           accepted risks true by construction rather than by two constants agreeing
           across two repositories.

           `detail` is the catalog's own summary with the count substituted, built in
           serve_identity_check_rollup ("x users without MFA" -> "62 users without MFA"),
           so the wording is the check's and not this widget's. A check that defines none
           renders no item. -->
      @if (topFailingFactors().length) {
        <div class="exposure-summary mt-2 pt-2 border-top" kendoTooltip filter=".badge">
          <small class="text-muted fw-medium d-block mb-1">Affected scope</small>
          @for (factor of topFailingFactors(); track factor.check_id) {
            @if (factor.detail) {
              <span class="badge bg-light text-dark me-2 mb-1" [title]="factor.detail">{{ factor.detail }}</span>
            }
          }
        </div>
      }
    }
  </div>
</div>
